import React, { useState, useEffect } from 'react';
import "../Layout/Layout.css";
import "../Layout/login.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons/faEyeSlash';
import { faEye } from '@fortawesome/free-solid-svg-icons/faEye';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const isScreen = windowWidth > 768;
  const content = isScreen ? <Desktop /> : <Mobile />;

  return (
    <body>
      {content}
    </body>
  );
};

const Desktop = () => {
  const user =[
    {username:"text1",password:"1234",sex:"nam",std:"0909471800"},
    {username:"text2",password:"1234",sex:"nữ",std:"0909471800"},
  ];
  const [username,setusername] = useState('');
  const [password,setpassword] = useState('');
  const [Notificationname,setNotificationname] = useState();
  const [Notificationpassword,setNotificationpassword] = useState();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePassword = (event) => {
    setpassword(event.target.value);
    setShowPassword(!showPassword);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!username) {
      setNotificationname('Nhập tên đăng nhập !');
      
    } else{
      setNotificationname('');
    }
    if (!password) {
      setNotificationpassword('Nhập mật khẩu !');
      return;
    } else{
      setNotificationpassword('');
    }
    const login = user.find(user => (user.username === username || user.std === username) && user.password === password );
    if (login) {
      navigate('/');
    } else {
      setNotificationname('Tên đăng nhập hoặc mật khẩu không đúng !');
    }
  };
  return (
    <body class='Desktop'>
      <div class='form-login-logout'>
        <div class='form-login'>
          <h1>ĐĂNG NHẬP</h1>
          <div class='form-login-1' style={{display:"flex"}}>
            <div class='button-icon'>
              <p>Facebook</p>
            </div>
            <div class='button-icon'>
              <p>Google</p>
            </div>
          </div>
          <div class='form-login-1'>
            <div class='line-button'>
              <div class='line'></div>
              <p style={{margin:"0"}}>Hoặc</p>
              <div class='line'></div>
            </div>
          </div>
          <form class='form-login-1' onSubmit={handleSubmit}>
            <label for="username">Tên Người Dùng / Số Điện Thoại</label>
            <div class='username'>
              <input type="text" name="username" id="username" placeholder="" value={username}  onChange={(e) => setusername(e.target.value)}></input>
              <div class='input-icon'>
                {username ?
                  (<FontAwesomeIcon icon={faCheck} class='icon' style={{color:"green"}}/>)
                  :
                  (<FontAwesomeIcon icon={faXmark} class='icon'style={{color:"red"}}/>)
                }
              </div>
            </div>
            <p class='Notification'>{Notificationname}</p>
            <hr></hr>
            <label fr="password">Mật Khẩu</label>
            <div class='password'>
              <input type={showPassword ? "text" : "password"}  name="password"  id="password" placeholder="" value={password} onChange={(e) => setpassword(e.target.value)}></input>
              <div  class='input-icon'onClick={handleTogglePassword}>
                <FontAwesomeIcon icon={faEyeSlash} class='icon'style={{display: showPassword ? 'block':'none'}}/>
                <FontAwesomeIcon icon={faEye} class='icon'     style={{display: showPassword ? 'none':'block'}}/>
              </div>
            </div>
            <p class='Notification'>{Notificationpassword}</p>
            <p class='forgot-password'><a href='/'>Quên mật khẩu ?</a></p>
            <div class='line-button'>
              <div class='line'></div>
              <button class='button' type="submit">Đăng nhập</button>
              <div class='line'></div>
            </div>
          </form>
          <div class='form-login-1' style={{display:"flex",justifyContent:"center",marginBottom:"20px"}}>
            <p style={{margin:"0px"}}>Bạn chưa có tài khoản ?</p>
            <a href='../logout'>Đăng ký</a>
          </div>
        </div>
        <div class='form-logout'>
          <div class='form-introduce'>
            <h1>Chào mừng bạn !</h1>
            <h1>Đã quay chở lại với nhà thuốc Phú Sang.</h1>
            <h3>Vui lòng đăng nhập để hưởng những đặc quyền dành cho khách hàng.</h3>
          </div>
          
        </div>
      </div>
    </body>
  );
};
const Mobile = () => {
  return (
    <body>
       
    </body>
  );
};
export default Login;
